import { lazy } from "react";
import { app } from "@/helpers/routes";
import { paths } from "@/router/paths";

const Conversations = lazy(() => import("@/pages/conversations"));
const Customers = lazy(() => import("@/pages/customers"));
const Analytics = lazy(() => import("@/pages/analytics"));

export const routes: Array<any> = [
  { path: paths.app.conversations, element: app(Conversations) },
  { path: paths.app.customers, element: app(Customers) },
  { path: paths.app.analytics, element: app(Analytics) },
];
